export const STANDARD_COLORS = {
  teal: "#20c997",
  green: "#2ba175",
  blue: "#007bff",
  purple: "#6f42c1",
  yellow: "#ffc107",
  orange: "#fd7e14",
  red: "#dc3545",
  brown: "#795548",
  pink: "#E83E8C",
  grey: "#58595B",
};

export const MEMBER_GROUPS = [
  {
    label: "Internal",
    value: "INTERNAL",
  },
  {
    label: "Admin",
    value: "ADMIN",
  },
  {
    label: "Partner",
    value: "PARTNER",
  },
  {
    label: "Kunde",
    value: "CLIENT",
  },
];
